const SEEN_KEY = 'pw:storiesSeen';

export function readStoriesSeen() {
    try {
        const raw = localStorage.getItem(SEEN_KEY);
        const parsed = raw ? JSON.parse(raw) : [];
        return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
        return [];
    }
}

export function writeStoriesSeen(ids) {
    try {
        localStorage.setItem(SEEN_KEY, JSON.stringify(ids));
    } catch (error) {
        console.error('Failed to save stories seen:', error);
    }
}

export function isStorySeen(businessId) {
    return readStoriesSeen().includes(String(businessId));
}

export function markStorySeen(businessId) {
    const id = String(businessId);
    const current = readStoriesSeen();
    if (!current.includes(id)) {
        writeStoriesSeen([...current, id]);
        window.dispatchEvent(new CustomEvent('pw:stories-seen-changed'));
    }
}